import type { GetPlacementMutation } from '@/features/ad-server/graphql/mutations/GetPlacement.mutation';
import type { AdServerLoadStatus } from '@/features/ad-server/composables/useAdServer';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export type AdServerPlacementData = GetPlacementMutation['getPlacement'];

export interface AdServerPlacement {
	data?: AdServerPlacementData;
	status: AdServerLoadStatus;
}

export const useAdServerStore = defineStore('adServer', () => {
	const placements = ref<Record<string, AdServerPlacement>>({});

	function setStatus(key: string, status: Exclude<AdServerLoadStatus, 'loaded'>) {
		if (placements.value[key]) {
			placements.value[key]['status'] = status;
		} else {
			placements.value[key] = { status };
		}
	}

	function setResponse(key: string, data: AdServerPlacementData) {
		placements.value[key] = { data, status: 'loaded' };
	}

	function clearResponse(key?: string) {
		if (key) {
			delete placements.value[key];
		} else {
			Object.keys(placements.value).forEach(k => delete placements.value[k]);
		}
	}

	return {
		placements,
		setStatus,
		setResponse,
		clearResponse,
	};
});
